module.exports = __webpack_public_path__ + "img/gaobaoCode.2ce244a8.png";